export const THEME_COLOR = {
    light: 'light',
    dark: 'dark',
}

export const THEME_MODIFIER = {
    normal: 'normal',
    contrast: 'contrast',
}
